import React from "react"
import { Icon } from "../../components"

export default function ({ calendarId }: { calendarId: string }) {
  const [calendarWidget] = React.useState(Boolean(window["Calendly"]))
  const calendarRef = React.useRef(null)
  const calendarUrl = React.useRef(`https://calendly.com/${calendarId}/15min`)

  React.useEffect(() => {
    if (!calendarWidget || !window["Calendly"]) return

    window["Calendly"].initInlineWidget({
      url: calendarUrl.current,
      parentElement: calendarRef.current,
      resize: true,
    })
  }, [calendarWidget])

  return (
    <>
      {calendarWidget ? (
        <div ref={calendarRef} style={{ minHeight: "200px" }}></div>
      ) : (
        <div className="text-center py-6">
          <h3>Want to chat?</h3>
          <p className="py-4">
            Let’s find a time that works for you! <br />
            Click the button below to book a meeting with us
          </p>
          <a
            href={calendarUrl.current}
            className="button primary md:w-fit w-full text-md text-center block mx-auto"
            target="_blank"
          >
            Find a Time
            <span className="inline-block w-3 h-3 ml-2 text-white">
              <Icon.ExternalLink />
            </span>
          </a>
        </div>
      )}
    </>
  )
}
